exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".highlighted{\r\n  border-radius: 4px;\r\n  background: #788990;\r\n};", "", {"version":3,"sources":["Z:/adminlte-2-react/src/components/Sidebar/Sidebar.css"],"names":[],"mappings":"AAAA;EACE,mBAAkB;EAClB,oBAAmB;CACrB,CAAA","file":"Sidebar.css","sourcesContent":[".highlighted{\r\n  border-radius: 4px;\r\n  background: #788990;\r\n};"],"sourceRoot":""}]);

// exports
